/**
 * テキストをHTMLエンティティにエンコードまたは、デコードする。
 * @param {string} text - HHTMLエンティティにエンコードまたは、デコードするテキスト
 */
import _ from 'lodash'

export default function escapeHtmlEntity(text: string) {
  const escapeText = _.escape(text)
  return escapeText
}

export function unescapeHtmlEntity(text: string) {
  const unescapeText = _.unescape(text)
  return unescapeText
}
